import PropTypes from 'prop-types';
import React, { useRef, useState, useCallback, forwardRef, useImperativeHandle } from 'react';
import { createChainedFunction } from '@atc/create-chained-function';
import Overlay from '../Overlay/index.js';
const OverlayTrigger = /*#__PURE__*/forwardRef(function (_temp, outerRef) {
  let {
    children,
    overlay,
    trigger = ['hover', 'focus'],
    placement = 'right',
    rootClose = false,
    onHide = () => {},
    onEnter = () => {},
    onFocus = () => {},
    onBlur = () => {},
    onClick = () => {},
    onMouseOver = () => {},
    onMouseOut = () => {},
    ...rest
  } = _temp === void 0 ? {} : _temp;
  const ref = useRef();
  const [showOverlay, setShowOverlay] = useState(false);
  useImperativeHandle(outerRef, () => ({
    setShowOverlay
  }));
  const handleHide = useCallback(() => {
    setShowOverlay(false);
    onHide();
  }, [setShowOverlay, onHide]);
  const handleShow = useCallback(() => {
    setShowOverlay(true);
  }, [setShowOverlay]);
  const handleToggle = useCallback(() => {
    if (showOverlay) {
      handleHide();
    } else {
      handleShow();
    }
  }, [handleHide, handleShow, showOverlay]);

  // Trigger can be either String or Array.
  // Convert it to Array for consistent formatting
  const triggers = [].concat(trigger);
  const triggerProps = {};
  if (triggers.indexOf('focus') > -1) {
    triggerProps.onFocus = createChainedFunction(handleShow, onFocus);
    triggerProps.onBlur = handleHide;
  }
  if (triggers.indexOf('hover') > -1) {
    triggerProps.onMouseOver = createChainedFunction(handleShow, onMouseOver);
    triggerProps.onMouseOut = createChainedFunction(handleHide, onMouseOut);
  }
  if (triggers.indexOf('click') > -1) {
    triggerProps.onClick = createChainedFunction(handleToggle, onClick);
  }

  // Bootstrap allows only one child
  const child = React.Children.only(children);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", Object.assign({}, rest, triggerProps, {
    ref: ref
  }), child), /*#__PURE__*/React.createElement(Overlay, Object.assign({}, rest, {
    placement: placement,
    target: ref?.current,
    show: showOverlay,
    rootClose: rootClose,
    onHide: handleHide,
    onEnter: onEnter
  }), overlay));
});
export default OverlayTrigger;